import type { CSSProperties, ReactNode } from "react";
import { useRef } from "react";
import { cn } from "../lib/utils";

interface GlowCardProps {
  children: ReactNode;
  glowColor?: string;
  intensity?: "low" | "medium" | "high";
  className?: string;
  style?: CSSProperties;
}

export function GlowCard({
  children,
  glowColor = "var(--primary)",
  intensity = "medium",
  className,
  style,
}: GlowCardProps) {
  const cardRef = useRef<HTMLDivElement>(null);

  function handleMouseMove(e: React.MouseEvent<HTMLDivElement>) {
    const card = cardRef.current;
    if (!card) return;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    card.style.setProperty("--glow-x", `${x}px`);
    card.style.setProperty("--glow-y", `${y}px`);
  }

  function handleMouseLeave() {
    const card = cardRef.current;
    if (!card) return;
    card.style.setProperty("--glow-x", "-9999px");
    card.style.setProperty("--glow-y", "-9999px");
  }

  const sizeMap = { low: "120px", medium: "200px", high: "320px" };

  return (
    <div
      ref={cardRef}
      className={cn("glow-card", className)}
      style={{
        "--glow-color": glowColor,
        "--glow-size": sizeMap[intensity],
        "--glow-x": "-9999px",
        "--glow-y": "-9999px",
        ...style,
      } as CSSProperties}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      <div className="glow-card-inner">{children}</div>
    </div>
  );
}
